export default function getTextFromHTML(html: string): string {
  if (!html) return ''
  return html.replace?.(/(?:<[^>]*>)/g, '').replace(/(?:&nbsp;)/g, ' ') ?? ''
}